
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

try {
  Object.keys(modules).forEach((path) => {
    const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
    if (match) {
      const [, lang] = match;
      const module = modules[path] as { default?: Record<string, string> };
      
      if (!messages[lang]) {
        messages[lang] = { translation: {} };
      }
      
      // دمج محتوى الترجمة
      if (module.default) {
        messages[lang].translation = {
          ...messages[lang].translation,
          ...module.default
        };
      }
    }
  });
} catch (error) {
  console.warn('⚠️ خطأ في تحميل ملفات الترجمة:', error);
}

// إذا لم يتم تحميل أي ترجمات، أضف ترجمة افتراضية فارغة
if (Object.keys(messages).length === 0) {
  messages.ar = { translation: {} };
  messages.en = { translation: {} };
}

export default messages;
